import React, { useRef } from "react";
import { AnimatedTextLines } from "../components/AnimatedTextLines";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const AnimatedHeaderSection = ({
  subTitle,
  title,
  text,
  textColor,
  withScrollTrigger = false,
}) => {
  const contextRef = useRef(null);
  const headerRef = useRef(null);

  const titleParts = title.split(" ");

  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: withScrollTrigger
        ? {
            trigger: contextRef.current,
          }
        : undefined,
    });

    // SECTION ENTRY
    tl.from(contextRef.current, {
      y: "50vh",
      duration: 1,
      ease: "circ.out",
    });

    // HEADER FADE IN
    tl.from(
      headerRef.current,
      {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power3.out",
      },
      "<+0.2"
    );

    // 🔥 STAGGER WORD ANIMATION
    tl.from(
      headerRef.current.querySelectorAll("h1 span"),
      {
        y: 120,
        opacity: 0,
        stagger: 0.12,
        duration: 1,
        ease: "power3.out",
      },
      "-=0.8"
    );
  }, []);

  return (
    <div ref={contextRef} className="overflow-visible">
      <div
        ref={headerRef}
        className="flex flex-col justify-center gap-10 pt-8 sm:gap-12"
      >
        {/* SUBTITLE */}
        <p
          className={`text-xs sm:text-sm font-light tracking-[0.4rem] uppercase px-6 md:px-10 ${textColor}`}
        >
          {subTitle}
        </p>

        {/* TITLE */}
        <div className="px-6 md:px-10">
          <h1
            className={`
              font-bold 
              uppercase
              leading-[0.85]
              tracking-[-0.02em]
              ${textColor}
              text-[clamp(3rem,10vw,8rem)]
            `}
          >
            {titleParts.map((part, index) => (
              <span key={index} className="block">
                {part}
              </span>
            ))}
          </h1>
        </div>
      </div>

      {/* LINE + DESCRIPTION */}
      <div className={`relative px-6 md:px-10 mt-6 ${textColor}`}>
        <div className="absolute inset-x-0 top-0 border-t-2" />

        <div className="py-10 sm:py-14 text-right">
          <AnimatedTextLines
            text={text}
            className={`font-light uppercase text-sm sm:text-base md:text-lg ${textColor} max-w-xl ml-auto`}
          />
        </div>
      </div>
    </div>
  );
};

export default AnimatedHeaderSection;
